module.exports = __webpack_public_path__ + "static/media/TUDublin.e745bcef.png";